import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import LadderAge from "../../../Models/Catalogue/Pipeline/LadderAge";
import { AppService, DomainTypes } from "../../../DomainTypes";
import { Catalogue } from "@singularsystems/neo-react-services";
import DataCache from "../../../Services/DataCache";

export default class LadderAgeCatalogueEntry extends CatalogueEntry<LadderAge> {

    private pipelinesApiClient = AppService.get(DomainTypes.ApiClients.CataloguePipeline);

    constructor() {
        super("Ladder Ages", LadderAge);
    }

    public get editRole() {
        return CatalogueRoles.LadderAges.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.ladderAges;
    }

    public getFetchEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.getLadderAges;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.saveLadderAges;
    }

    public renderRow(ladderAge: LadderAge, meta: Model.TransformMetaType<LadderAge>) {
        return (
            <NeoGrid.RowGroup expandProperty={meta.isExpanded} >
                <NeoGrid.Row>
                    <NeoGrid.Column bind={meta.description} />
                    <NeoGrid.Column bind={meta.daysStart} />
                    <NeoGrid.Column bind={meta.daysEnd} />
                    <Catalogue.ButtonColumn />
                </NeoGrid.Row>
                <NeoGrid.ChildRow>
                    <NeoGrid.Grid items={ladderAge.ladderLimits} addButton={{ text: "Add Ladder Limit", size: "sm" }} >
                        {(ladderLimits, childMeta) => (
                            <NeoGrid.RowGroup>
                                <NeoGrid.Row title="Ladder Limits">
                                    <NeoGrid.Column bind={childMeta.effectiveDate} />
                                    <NeoGrid.Column bind={childMeta.limit} />
                                    <NeoGrid.ButtonColumn showDelete />
                                </NeoGrid.Row>
                            </NeoGrid.RowGroup>
                        )}
                    </NeoGrid.Grid>
                </NeoGrid.ChildRow>
            </NeoGrid.RowGroup>
        )
    }
}